(function() {
    angular
        .module('emarket.main.profile')
        .controller('AddBalanceDialogController', ['$log', '$sce', '$timeout', '$mdDialog', 'Transaction', function($log,
            $sce,
            $timeout,
            $mdDialog,
            Transaction) {
            var vm = this;
            vm.loading = true;
            Transaction.getConfig()
                .then(function(config) {
                    $log.info(config);
                    vm.loading = false;
                    vm.url = $sce.trustAsResourceUrl(config.url);
                    vm.payment = {
                        MerchantId: config.merchantid,
                        MerchantName: config.tradeName,
                        MerchantType: 'e-commerce',
                        CurrencyCode: '$',
                        ITBIS: 0,
                        ApprovedUrl: config.approvedUrl,
                        DeclinedUrl: config.declinedUrl,
                        CancelUrl: config.cancelUrl,
                        UseCustomField1: '0',
                        CustomField1Label: '',
                        CustomField1Value: '',
                        UseCustomField2: '0',
                        CustomField2Label: '',
                        CustomField2Value: ''
                    };
                })
                .catch(function() {
                    vm.loading = false;
                });

            var notSubmit = true;
            vm.createHash = function($event, form) {
                if (!form.$valid) {
                    $event.preventDefault();
                    return;
                }
                if (notSubmit) {
                    $event.preventDefault();
                    Transaction.createHash(vm.payment).then(function(response) {
                        vm.payment.AuthHash = response.hash;
                        vm.payment.ITBIS = response.amount.itbis;
                        vm.payment.Amount = response.amount.total;
                        vm.payment.OrderNumber = response.orderNumber;
                        vm.payment.ApprovedUrl = response.ApprovedUrl;
                        vm.payment.CancelUrl = response.CancelUrl;
                        vm.payment.DeclinedUrl = response.DeclinedUrl;
                        notSubmit = false;
                        $timeout(function() {
                            // $('#AuthHash').val(response.hash);
                            // $('#ITBIS').val(response.amount.itbis);
                            // $('#Amount').val(response.amount.total);
                            // $('#OrderNumber').val(response.orderNumber);
                            $('#addBalanceForm').submit();
                        }, 500);
                    });
                }
            };
            vm.close = function() {
                $mdDialog.hide();
            };
        }]);
}());
